import axios from "axios";
import { SearchSuggestion, SearchSuggestionApi } from "../types/search.types";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";

const normalizeSearchSuggestion = (
  item: SearchSuggestionApi
): SearchSuggestion | null => {
  const code = String(
    item.code ?? item.mappingCode ?? item.productCode ?? item.id ?? ""
  ).trim();
  const productName = String(
    item.productName ?? item.name ?? item.product ?? ""
  ).trim();

  if (!code || !productName) return null;
  return { code, productName };
};

/**
 * Fetch product search suggestions from the API.
 * Returns an empty array on failure — never throws.
 */
export const fetchSearchSuggestions = async (
  query: string
): Promise<SearchSuggestion[]> => {
  try {
    const response = await axios.get(
      `${PKSOFT_URLS.CUSTOMER.SEARCH}/${encodeURIComponent(query.trim())}`
    );
    if (response.data.status === 200 && Array.isArray(response.data.data)) {
      return (response.data.data as SearchSuggestionApi[])
        .map(normalizeSearchSuggestion)
        .filter((item): item is SearchSuggestion => item !== null);
    }
    return [];
  } catch (error) {
    console.error("Search suggestions error:", error);
    return [];
  }
};
